import type { StateCreator } from "../store";
import type { AppStore } from "../index";

export interface DialogState {
  type: "alert" | "confirm";
  title?: string;
  message: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export interface DialogSlice {
  dialogState: DialogState | null;
  openDialog: (dialog: DialogState) => void;
  closeDialog: () => void;
}

export const createDialogSlice: StateCreator<AppStore, unknown, unknown, DialogSlice> = (set) => ({
  dialogState: null,

  openDialog: (dialog) =>
    set((state) => {
      state.dialogState = dialog;
    }),

  closeDialog: () =>
    set((state) => {
      state.dialogState = null;
    }),
});
